import "./index.scss"


/** WEBPACK FOOTER **
 ** ./src/About/index.js
 **/